import { callFunction } from './functionsService';

export async function grantCoinVisitorAccess(phoneNumber) {
  return callFunction('grantCoinVisitorAccess', { phoneNumber });
}

export async function listSharedCoinViews() {
  return callFunction('listSharedCoinViews');
}

export async function listCoinVisitors() {
  return callFunction('listCoinVisitors');
}

export async function revokeCoinVisitorAccess(accessId) {
  return callFunction('revokeCoinVisitorAccess', { accessId });
}
